import { useEffect } from 'react'

interface DocumentMeta {
  title: string
  description: string
  image?: string
  siteName?: string
}
const DEFAULT_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/fdbe885c-e494-4ec5-b9e6-47e98ba13ef7.jpg'

function setMeta(selector: string, attribute: 'name' | 'property', key: string, content: string) {
  let tag = document.head.querySelector<HTMLMetaElement>(selector)

  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute(attribute, key)
    document.head.appendChild(tag)
  }

  tag.setAttribute('content', content)
}

export function useDocumentMeta({
  title,
  description,
  image = DEFAULT_IMAGE,
  siteName,
}: DocumentMeta) {
  useEffect(() => {
    document.title = title

    const resolvedSiteName = siteName ?? title.split('—').pop()?.trim() ?? title

    setMeta('meta[name="description"]', 'name', 'description', description)
    setMeta('meta[property="og:site_name"]', 'property', 'og:site_name', resolvedSiteName)
    setMeta('meta[property="og:type"]', 'property', 'og:type', 'website')
    setMeta('meta[property="og:title"]', 'property', 'og:title', title)
    setMeta('meta[property="og:description"]', 'property', 'og:description', description)
    setMeta('meta[property="og:image"]', 'property', 'og:image', image)
    setMeta('meta[property="og:url"]', 'property', 'og:url', window.location.href)
    setMeta('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary_large_image')
    setMeta('meta[name="twitter:title"]', 'name', 'twitter:title', title)
    setMeta('meta[name="twitter:description"]', 'name', 'twitter:description', description)
    setMeta('meta[name="twitter:image"]', 'name', 'twitter:image', image)
  }, [title, description, image, siteName])
}
